import { put } from 'redux-saga/effects';
import { dismissAlertFail, dismissAlertSuccess } from './actions';
import { dismissAlert } from './backend';
import { goBack } from '../../../../../routing/redirectService';
import { makeErrorPayload } from '../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../shared/toast/redux/actions';

export function* dismissAlertSaga(action) {
    try {
        const { alertId, reason, note } = action.payload;
        const response = yield dismissAlert(alertId, reason, note);

        yield put(dismissAlertSuccess(response.data));
        // yield put(
        //     setSuccessToast(makeSuccessPayload('Successfully dismissed Alert!'))
        // );
        goBack();
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(dismissAlertFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
